import { render, staticRenderFns } from "./PortMasterNavigation.vue?vue&type=template&id=f49b9f20&scoped=true&"
import script from "./PortMasterNavigation.vue?vue&type=script&lang=js&"
export * from "./PortMasterNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PortMasterNavigation.vue?vue&type=style&index=0&id=f49b9f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49b9f20",
  null
  
)

export default component.exports